import { FieldIsDirtyType } from "../../../../common/utility-types/FieldIsDirtyType";
import { UICustomizationFieldIsDirtyType, UICustomizationFieldType } from "../../../../components/ui-customization-settings/UICustomizationSettingsFieldTypes";
import { UserRecipientFieldIsDirtyType, UserRecipientFieldType } from "../../../../components/user-recipient-list/UserRecipientFieldTypes";

export enum UICustomizationModeTypeEnum {
    None = 0,
    Preset = 1,
    Custom = 2
}

export type UserFieldType = {
    id: number;
    firstName: string | undefined;
    lastName: string | undefined;
    companyName: string | undefined;
    jobTitle: string | undefined;
    jobFunction: string | undefined;
    phoneNumber: string | undefined;
    timeZoneIndex: number;
    login: string | undefined;
    lastLoginTimestamp: string | undefined;
    sendNewUserNotification: boolean;
    requirePasswordChange: boolean;
    disabled: boolean;
    mobileAccessEnabled: boolean;
    multipleCustomers: boolean;
    isElynxAdmin: boolean;
    recipients: Array<UserRecipientFieldType>;
    associatedRoles: Array<UserAssociatedRoleFieldType>;
    createEmailRecipient?: boolean;
    createSmsRecipient?: boolean;
    createVoiceRecipient?: boolean;

    mfaEnabled: boolean;
    mfaSource?: string;

    externalSignInName: string | undefined;

    allowSSO: boolean; // Optional, used to determine if SSO is allowed for the user
    uiCustomizationPresetID?: number;

    // UI Only
    hasUICustomizationSettings: boolean;
    uiCustomizationMode: UICustomizationModeTypeEnum;

} & UICustomizationFieldType;

export type UserFieldIsDirtyType = FieldIsDirtyType<UserFieldType>;
// export type UserFieldIsDirtyType = FieldIsDirtyType<Omit<UserFieldType, "recipients" | "associatedRoles" | "customizationSettings">> & {
//     recipients?: Array<UserRecipientFieldIsDirtyType>;
//     associatedRoles?: Array<UserAssociatedRoleFieldIsDirtyType>;
// } & UICustomizationFieldIsDirtyType;

export type UserAssociatedRoleFieldType = {
    id: number;
}

export type UserAssociatedRoleFieldIsDirtyType = FieldIsDirtyType<UserAssociatedRoleFieldType>;